import { FC } from 'react'
import Link from 'next/link'

import { Pathname } from 'constants/data'

import styles from './webinar-template.module.scss'

interface IJoinTemplate {
  formedLink: string | number | undefined
  eventType: string
}

const JoinArrangment: FC<IJoinTemplate> = ({ formedLink, eventType }) => (
  <>
    <p>
      Участие в мероприятии бесплатное. Для входа на мероприятие перейдите по ссылке&ensp;
      <Link className={styles.link} href={`/${Pathname.WEBINAR}/${formedLink}`} prefetch={false}>
        medpoint.pro/webinar/{formedLink}
      </Link>
    </p>
    <br />
    <p>
      Убедитесь, пожалуйста, заранее, что у вас установлена последняя версия браузеров Google
      Chrome, FireFox, Safari или Opera. Рекомендуемая скорость интернет соединения – от 2Mb,
      минимальная для подключения – 1Mb.
    </p>
    <br />
    <p>
      {eventType}, напишите нам на&ensp;
      <a href="mailto:info@medpoint.pro" className={styles.link}>
        info@medpoint.pro
      </a>
      .
    </p>
  </>
)
export default JoinArrangment
